import { onMounted } from 'vue'
import useGet from '../../../core/composables/api/useGet'
import { type Dialog } from '../../../core/models/dialog/dialog'

export const useConductedDialogs = () => {
  const { data, load, status } = useGet<ReadonlyArray<Dialog>>(`dialog/conducted`)

  onMounted(() => {
    load()
  })

  return { status, data }
}
